import React from 'react';

export const ShodiText = () => {
  return (
    <p>
      Використовують,зокрема, як евакуаційний шлях. За наявності декількох сходових кліток на поверху маршрут евакуації
      прокладають до найближчих сходів. <br /> Клацніть лiвою кнопкою миші на значок і перетягніть на План у зазначене
      місце.
    </p>
  );
};
